import { render, staticRenderFns } from "./institution_site.vue?vue&type=template&id=99e86cc6&"
import script from "./institution_site.vue?vue&type=script&lang=js&"
export * from "./institution_site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports